import { render, staticRenderFns } from "./CreateReview.vue?vue&type=template&id=10062626&"
import script from "./CreateReview.vue?vue&type=script&lang=js&"
export * from "./CreateReview.vue?vue&type=script&lang=js&"
import style0 from "./CreateReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports